<div
  class="visualization-container"
  [style.border-color]="borderColor"
  [style.background-color]="backgroundColor"
  [style.gap.rem]="(distributionsAreEqual$ | async) ? 1 : 1.5">
  <div class="label-sm">{{ label }}</div>
  <div class="d-flex flex-column gap-3">
    <ng-container *ngFor="let group of instructionsGroupedByAccount$ | async">
      <div *ngIf="!(distributionsAreEqual$ | async)" class="d-flex flex-column gap-2">
        <div class="account-name">{{ group.accountName }}</div>
        <div class="account-id">{{ group.accountId }}</div>
      </div>
      <div #grid [ngStyle]="gridStyles$ | async">
        <app-investment-instructions-card *ngFor="let instruction of group.instructions" [instruction]="instruction" />
      </div>
    </ng-container>
  </div>
</div>
